import { gql } from '@apollo/client';

export const PREVIEW_PIPEDRIVE_CSV = gql`
    query PreviewPipedriveCsv($input: PreviewPipedriveCsvInput!) {
        previewPipedriveCsv(input: $input) {
            headers
            rowCount
            suggestedMapping {
                csvHeader
                target
            }
        }
    }
`;
